import React, { Children, FC, PropsWithChildren } from 'react';
import { Paper } from '@dev/ee-components';

import useMobile from '@/services/hooks/useMobile';

export const ContentVariantWrapper: FC = ({ children }: PropsWithChildren<never>): JSX.Element => {
    const isMobile = useMobile();

    if (isMobile) {
        return children;
    }

    const [searchBar, table] = Children.toArray(children);

    return (
        <Paper>
            <div className="TableHeader">{searchBar}</div>
            {table}
        </Paper>
    );
};
